<template>
    <div class="columns">
        <div class="column is-fullwidth">
            <b class="is-inline region-header" @click="selectAllAuctionsByRegion(region)">
                {{ region }}
            </b>
            <hr>
            <div class="columns is-multiline is-flex m-0">
                <auction v-for="(auction, index) in getAuctionsByRegion(region)" :auction="auction" :key="index" :region="region"></auction>
            </div>
        </div>
    </div>
</template>

<script>
    import Auction from './Auction.vue'
    export default {
        props: ['region', 'counter'],
        components: {
            Auction
        },
        methods: {
            getAuctionsByRegion(region) {
                return this.$store.getters.getAllAuctionsByRegion(region)
            },
            selectAllAuctionsByRegion(region) {
                this.$store.dispatch('addAllAuctionsByRegionForAllDays', region)
            }
        }
    }
</script>

<style scoped>
    .region-header {
        cursor: pointer;
    }
    hr {
        margin: 10px!important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/Inputs/Auctions.vue